import store from '../store'
import axios from 'axios'

let instance
/* eslint-disable */
instance = axios.create()
instance.defaults.headers.common.client_id = 'geclisaAutoRecepcion'

instance.interceptors.request.use(async (config) => {
  const url = store.state.apiUrl
  config.baseURL = `${url}/api`
  store.commit('incrementAjaxCounter')
  return config
})

instance.interceptors.response.use(response => {
  store.commit('decrementAjaxCounter')
  return response
}, error => {
  /* eslint-disable */
  console.log(error)
  /* eslint-enable */
  store.commit('decrementAjaxCounter')
  if (!error.config.__isRetryRequest && (typeof error.response === 'undefined' || error.response.status !== 400)) {
    error.config.__isRetryRequest = true
    return axios(error.config)
  } else if (error.config.__isRetryRequest && (typeof error.response === 'undefined' || error.response.status !== 400)) {
    window.location.href = '/error'
  }
  return Promise.reject(error)
})
export default instance
